
	import {
		IonApp,
		IonList,
		IonRouterOutlet,
		IonIcon,
		IonSplitPane,
		IonLabel,
		modalController,
		IonItem,
		IonContent,
		IonMenu,
		IonToolbar,
		IonTitle,
		IonNote,
		IonHeader,
		IonButton,
		IonButtons,
		IonImg,
	} from "@ionic/vue";
	import { defineComponent, getCurrentInstance } from "vue";
	import { useRouter } from "vue-router";
	import { logOut } from "ionicons/icons";
	import LoginPage from "./views/Login/LoginPage.vue";
	import { LoginUtility } from "./views/LoginUtility/LoginUtility";
	import { useApplicationStore } from "./stores/ApplicationStore";

	export default defineComponent({
		name: "AppPage",
		components: {
			IonApp,
			IonContent,
			IonList,
			IonToolbar,
			IonRouterOutlet,
			IonSplitPane,
			IonIcon,
			IonLabel,
			IonItem,
			IonMenu,
			IonHeader,
			IonTitle,
			IonNote,
			IonButton,
			IonButtons,
			IonImg,
		},

		data() {
			return {
				Menu: [] as any,
			};
		},

		computed: {
			isLogImpty() {
				return this.LOGO_IMAGE === "";
			},
		},

		setup() {
			const router = useRouter();
			const instance: any = getCurrentInstance();
			const app_tile = instance.appContext.config.globalProperties.$APP_TITLE;
			const LOGO_BACKGROUND_COLOR =
				instance.appContext.config.globalProperties.$LOGO_BACKGROUND_COLOR ||
				"#ffffff";
			const LOGO_IMAGE =
				instance.appContext.config.globalProperties.$LOGO_IMAGE;
			const LOGO_TEXT =
				instance.appContext.config.globalProperties.$LOGO_TEXT || "";

			const openLogin = async () => {
				const login = new LoginUtility();
				router.push("/homepage");
				login.LogOut();

				const modal = await modalController.create({
					component: LoginPage,
					cssClass: "fullscreen",
					canDismiss: canDismiss,
				});

				await modal.present();
			};

			async function canDismiss() {
				const appStore = useApplicationStore();
				return appStore.$APP_READY;
			}

			return {
				router,
				logOut,
				openLogin,
				app_tile,
				LOGO_BACKGROUND_COLOR,
				LOGO_TEXT,
				LOGO_IMAGE,
			};
		},

		methods: {
			navigate(route: string) {
				const menu = document.querySelector("ion-menu");
				menu?.close();
				if (route) {
					this.router.push(route);
				}
			},
			getMenuItem() {
				fetch("/Menu.json")
					.then((response) => response.json())
					.then((menu) => {
						this.Menu = menu.Menu;
					});
			},
		},

		mounted() {
			document.title = this.app_tile;
			this.getMenuItem();
		},
	});
